// extracted by mini-css-extract-plugin
export default {"table_wrapper":"ListPegawai_table_wrapper__c1Dyf","header_container":"ListPegawai_header_container__eiK56"};